import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import { locale, supportedLocales, setUserLocale, loadLocale } from '../../i18n.js';
import { authState } from '../../state/auth.js';

export default function LanguageSwitcher() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const locales = supportedLocales.value;
  const current = locales.find(l => l.code === locale.value);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  const handleSelect = async (code) => {
    setOpen(false);
    if (authState.value.authenticated) {
      await setUserLocale(code);
    } else {
      await loadLocale(code);
    }
  };

  return (
    <div class="lang-switcher" ref={ref}>
      <button class="lang-switcher-btn" onClick={() => setOpen(!open)}>
        <span>{current?.flag || '🌐'}</span>
        <span>{(current?.code || locale.value).toUpperCase()}</span>
      </button>

      {open && (
        <div class="lang-switcher-dropdown">
          {locales.map(l => (
            <div
              key={l.code}
              class={`lang-option ${l.code === locale.value ? 'lang-option-active' : ''}`}
              onClick={() => handleSelect(l.code)}
            >
              <span>{l.flag}</span>
              <span>{l.label}</span>
              {l.code === locale.value && <span style="margin-left:auto">✓</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
